export default [
  {
    path: 'announcements',
    name: 'announcements',
    component: () => import('@/views/Announcement/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      template: 'auth',
      name: 'announcement',
    },
  },
  {
    path: 'announcement-content/:id',
    name: 'announcementContent',
    component: () => import('@/views/Announcement/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      template: 'auth',
      name: 'announcement',
    },
  },
];
